import { Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import useProtectedClient from '../../../hooks/useProtectedClient';
import { getOrders } from '../../../api/order/orderApi';
import OrderItem from '../OrderItem';
import ProductRowLoader from '../../marketWidget/productRow/ProductRowLoader';
import { useNotification } from '../../../context/NotificationProvider';

const OrdersList = () => {
    const [isLoading, setIsLoading] = useState(true)
    const protectedClient = useProtectedClient();
    const {showNotification} = useNotification();
    const [orders, setOrders] = useState([])
    const fetchOrders = async () => {
        try {
            const res = await getOrders(protectedClient);
            setOrders(res)
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setIsLoading(false);
        }
    };
    useEffect( () => {
        fetchOrders();
    }, []);
    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            padding={2}
            sx={{ 
                height: "90vh",
                width: "100%",
                marginBottom: "100px",
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            {!isLoading
            ? 
                <>
                    {orders.map((item, index) => (
                        <OrderItem key={index} item={item} onChange={fetchOrders}/>
                    ))}
                </> 
            :
                <>
                    <ProductRowLoader />
                    <ProductRowLoader />
                    <ProductRowLoader />
                </>
            }
            
        </Box>
    );
};

export default OrdersList;
